import api from '@/api'
import FilterCustomer from '@/components/elements/FilterCustomer'
import config from '@/config'
import moment from 'moment'
import { default as Multiselect, default as multiselect } from 'vue-multiselect'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'
import CustomerItem from './CustomerItem'
import DateFilter from './TheNextFaceDateFilter'

export default {
  data: function () {
    var headers = []
    // console.log(this.$store.state.selectedBot)

    if (this.$store.state.selectedBot.theme == 'hafele') {
      headers.push({ text: this.$t('ID'), value: 'emp_id' })
    }
    headers.push({ text: '', sortable: false })
    if (this.$store.state.selectedBot.pageid == '100701258941039') {
      headers.push({ text: 'memberid', value: 'memberid' })
      headers.push({ text: 'ชื่อร้านค้า', value: 'shopname' })
      headers.push({ text: 'จังหวัด', value: 'shopprovince' })
    } else if (this.$store.state.selectedBot.type == 'summithr') {
      headers = headers.concat([
        { text: this.$t('name'), value: 'first_name' },
        { text: 'สถานะพนักงาน', value: 'member_status' },
        { text: this.$t('Channel'), value: 'app' },
        { text: this.$t('gender'), value: 'gender' },
        { text: this.$t('Register Date'), value: 'registertimestamp' },
        { text: this.$t('Last Active Date'), value: 'timestamp' },
        { text: this.$t('Email'), value: 'email' },
        { text: this.$t('phone no.'), value: 'phoneno' },
        { text: this.$t('Status'), value: 'status' },
        { text: this.$t('Locale'), value: 'locale' },
        { text: this.$t('Lineid'), value: 'lineid' },
        { text: this.$t('Province'), value: 'province' },
        { text: this.$t('School'), value: 'school' },
        { text: '', sortable: false }
      ])
    } else if (this.$store.state.selectedBot.type == 'nextcapital') {
      headers = headers.concat([
        // { text: '', sortable: false },
        { text: this.$t('name'), value: 'first_name' },
        { text: this.$t('Channel'), value: 'app' },
        { text: this.$t('gender'), value: 'gender' },
        { text: this.$t('next_capital_register_date'), value: 'login_timestamp' },
        { text: this.$t('Register Date'), value: 'registertimestamp' },
        { text: this.$t('Last Active Date'), value: 'timestamp' },
        { text: this.$t('Email'), value: 'email' },
        { text: this.$t('phone no.'), value: 'phoneno' },
        { text: this.$t('Status'), value: 'status' },
        { text: this.$t('Locale'), value: 'locale' },
        { text: this.$t('Lineid'), value: 'lineid' },
        { text: this.$t('Province'), value: 'province' },
        { text: this.$t('School'), value: 'school' },
        { text: '', sortable: false }
      ])
    } else {
      headers = headers.concat([
        // { text: '', sortable: false },
        { text: this.$t('name'), value: 'first_name' },
        { text: this.$t('Channel'), value: 'app' },
        { text: this.$t('gender'), value: 'gender' },
        { text: this.$t('Register Date'), value: 'registertimestamp' },
        { text: this.$t('Last Active Date'), value: 'timestamp' },
        { text: this.$t('Email'), value: 'email' },
        { text: this.$t('phone no.'), value: 'phoneno' },
        { text: this.$t('Status'), value: 'status' },
        { text: this.$t('Locale'), value: 'locale' },
        { text: this.$t('Lineid'), value: 'lineid' },
        { text: this.$t('Province'), value: 'province' },
        { text: this.$t('School'), value: 'school' },
        { text: '', sortable: false }
      ])
    }

    return {
      selectedCom7page: {
        pageid: null,
        name: ''
      },
      headers: headers,
      pageNumber: 1,
      pagination: { rowsPerPage: -1, sortBy: '' },
      tag: '',
      singleStatus: '',
      showAdvance: false,
      users: [],
      limit: 100,
      offset: 0,
      hasNext: true,
      count: 0,
      gendercount: '',
      users_count: [],
      intents: [],
      delayImport: false,
      search: '',
      filter: {
        fullname: '',
        gender: {
          label: this.$t('All'),
          value: 'all'
        },
        locale: null,
        app: {
          label: this.$t('All'),
          value: 'all'
        },
        intent: null,
        email: '',
        phoneno: '',
        messagesent: {
          value: null,
          symbol: {
            value: 'g__',
            label: this.$t('Greater than')
          }
        },
        timezone: {
          from: -12,
          to: 14
        },
        activeDate: {
          enable: false,
          start: null,
          end: null
        },
        registerDate: {
          enable: false,
          start: null,
          end: null
        },
        status: '',
        tags: '',
        tagtype: 'includes',
        lineid: '',
        school: '',
        province: '',
        uu_register_status: '',
        specialcondition: '',
        statustype: 'includes',
        member_status: ''
      },
      loading: true,
      errorFilterTag: [],
      pagetmp: 1,
      errorFilterStatus: [],
      customerfromfb: null,
      total_user: '',
      exportlimit: 5000,
      showExport: false,
      exportpagecount: 0,
      exportType: null,
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD HH:mm'),
        end: moment().format('YYYY-MM-DD HH:mm')
      },
      selectedCom7page: {
        pageid: null,
        name: ''
      },

      createCustomAudienceDialog: false,
      customAudienceName: null,

      historyCustomAudiencePage: false
    }
  },
  components: {
    ScaleLoader,
    CustomerItem,
    PulseLoader,
    Multiselect,
    FilterCustomer,
    multiselect,
    DateFilter
  },
  mounted: async function () {
    if (['studio7', 'ticket2'].includes(this.selectedBot.theme)) {
      let com7page = this.$store.state.com7pages.find((f) => f.pageid == this.selectedBot.pageid)
      this.selectedCom7page.name = com7page.name
    }
    this.initCustomer()
  },
  computed: {
    pagelength() {
      if (this.total_user) {
        return Math.ceil(this.total_user / 100)
      } else {
        return 1
      }
    },
    isBU() {
      return this.$store.state.pageBU.includes(this.selectedBot.pageid)
    },
    usersFormat() {
      if (this.users && this.users.length) {
        let temp = []
        this.users.forEach((ele) => {
          let obj = ele
          try {
            obj.json_variable = obj.json_variable ? JSON.parse(obj.json_variable) : {}
          } catch (error) {
            obj.json_variable = {}
            console.error(error)
          }
          obj.memberid =
            obj.json_variable && obj.json_variable.memberid ? obj.json_variable.memberid : ''
          temp.push(obj)
        })
        return temp
      } else {
        return []
      }
    },
    filteredHeader() {
      Array.prototype.insert = function (index) {
        index = Math.min(index, this.length)
        arguments.length > 1 &&
          this.splice.apply(this, [index, 0].concat([].pop.call(arguments))) &&
          this.insert.apply(this, arguments)
        return this
      }

      if (this.isBU) return this.headers
      else if (this.$store.state.niveapage.includes(this.selectedBot.pageid)) {
        return [
          { text: '', sortable: false },
          { text: this.$t('name'), value: 'first_name' },
          { text: this.$t('Channel'), value: 'app' },
          { text: this.$t('gender'), value: 'gender' },
          { text: this.$t('Message Sent'), value: 'usermessages' },
          { text: this.$t('Register Date'), value: 'registertimestamp' },
          { text: this.$t('Last Active Date'), value: 'timestamp' },
          { text: this.$t('Email'), value: 'email' },
          { text: this.$t('phone no.'), value: 'phoneno' },
          { text: this.$t('Status'), value: 'status' },
          { text: this.$t('Locale'), value: 'locale' },
          { text: '', sortable: false }
        ]
      } else if (this.$store.state.lamyPage.includes(this.selectedBot.pageid)) {
        return [
          { text: '', sortable: false },
          { text: this.$t('Name'), value: 'first_name' },
          { text: this.$t('Channel'), value: 'app' },
          { text: this.$t('Register Date'), value: 'registertimestamp' },
          { text: this.$t('Last Active Date'), value: 'timestamp' },
          { text: this.$t('level'), value: 'member_type' },
          { text: this.$t('total_purchase'), value: 'total_purchase' },
          { text: this.$t('Tag'), value: 'tag' },
          { text: this.$t('member_status'), value: 'member_status' }
        ]
      } else if (this.selectedBot.theme == 'scgdistribution') {
        return this.headers
          .filter((v) => {
            return !['lineid', 'province', 'school'].includes(v.value)
          })
          .insert(2, [
            {
              text: this.$t('Shop code'),
              value: 'cardnumber',
              align: 'left',
              width: 'auto'
            },
            {
              text: this.$t('Shop name'),
              value: 'realname',
              align: 'left',
              width: 'auto'
            },
            {
              text: this.$t('Province'),
              value: 'province',
              align: 'left',
              width: 'auto'
            }
          ])
      } else {
        return this.headers.filter((v) => {
          return !['lineid', 'province', 'school'].includes(v.value)
        })
      }
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCoachlab: 'isCoachlab',
      computedImportDelay: 'getDelayCustomerImport'
    }),
    pageid: function () {
      return this.$store.state.selectedBot.pageid
    },
    filterIntent: function () {
      var vm = this
      vm.intents.sort(function (a, b) {
        var nameA = a.intentname.toUpperCase() // ignore upper and lowercase
        var nameB = b.intentname.toUpperCase() // ignore upper and lowercase
        if (a.intentname[0] == '{' && a.intentname[a.intentname.length - 1] == '}') {
          return 1
        }
        if (b.intentname[0] == '{' && b.intentname[b.intentname.length - 1] == '}') {
          return -1
        }
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }

        // names must be equal
        return 0
      })
      var intents = []
      $.each(vm.intents, function (index, intent) {
        intents.push(intent.intentname)
      })
      return intents
    },
    tags: {
      get() {
        let vm = this
        if (vm.filter && vm.filter.tags && vm.filter.tags !== '') {
          var tags = []
          tags = vm.filter.tags.split(',')
          var result = []
          if (tags) {
            tags.map(function (tag, index) {
              result.push({ text: tag })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function (tag, index) {
            result.push(tag.text)
          })
        }
        vm.filter.tags = result.join(',')
      }
    },
    status: {
      get() {
        let vm = this
        if (vm.filter && vm.filter.status && vm.filter.status !== '') {
          var status = []
          status = vm.filter.status.split(',')
          var result = []
          if (status) {
            status.map(function (s, index) {
              result.push({ text: s })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function (s, index) {
            result.push(s.text)
          })
        }
        vm.filter.status = result.join(',')
      }
    }
  },
  methods: {
    async updateCustomAudience(audience_id, user_ids) {
      var data = {
        pageid: this.selectedBot.pageid,
        audience_id: audience_id,
        body: { user_ids: user_ids }
      }
      var response = await api.updateCustomAudience(data)
      if (response.success) {
        return response
      }
    },
    async createCustomAudience() {
      var vm = this
      console.log('create custom', vm.users.length)
      try {
        if (this.users && this.users.length > 0) {
          for (let i = 0; i < vm.users.length; i += 10000) {
            const chunk = vm.users
              ? vm.users
                  .filter((user) => {
                    return user.app == 'facebook'
                  })
                  .slice(i, i + 10000)
                  .map((user) => {
                    return user.id
                  })
              : []
            if (i < 10000) {
              var data = {
                pageid: vm.selectedBot.pageid,
                body: { user_ids: chunk, custom_audience_name: 'ZWIZ_' + vm.customAudienceName }
              }
              vm.$store.dispatch('loading')
              vm.createCustomAudienceDialog = false
              var response = await api.createCustomAudience(data)
              vm.customAudienceName = ''
              if (response && response.success && vm.users.length <= 10000) {
                vm.$swal.fire({
                  title: vm.$t('Successfully'),
                  type: 'success',
                  confirmButtonText: vm.$t('Confirm'),
                  reverseButtons: true
                })
                vm.$store.dispatch('loading')
              } else {
                vm.$store.dispatch('loading')
                vm.createCustomAudienceDialog = false
                if (vm.users.length <= 10000) {
                  vm.$swal.fire({
                    title: vm.$t('error'),
                    text: `${response.response.data.result.error.message} : ${response.response.data.result.error.error_user_msg}`,
                    type: 'error',
                    confirmButtonText: vm.$t('Confirm'),
                    reverseButtons: true
                  })
                }
              }
            } else {
              var responseUpdate = await vm.updateCustomAudience(response.result.audience_id, chunk)
              if (
                responseUpdate &&
                responseUpdate.success &&
                vm.users.length === i + responseUpdate.result.num_received
              ) {
                vm.$store.dispatch('loading')
                vm.$swal.fire({
                  title: vm.$t('Successfully'),
                  type: 'success',
                  confirmButtonText: vm.$t('Confirm'),
                  reverseButtons: true
                })
              }
            }
          }
        } else {
          this.$swal.fire({
            title: 'เพจของคุณยังไม่มีลูกค้าเก่า',
            type: 'error',
            confirmButtonText: this.$t('Confirm'),
            reverseButtons: true
          })
        }
      } catch (error) {
        console.error(error)
        this.$store.dispatch('loading')
        this.createCustomAudienceDialog = false
        if (this.users.length <= 10000) {
          this.$swal.fire({
            title: this.$t('error'),
            text: error.message,
            type: 'error',
            confirmButtonText: this.$t('Confirm'),
            reverseButtons: true
          })
        }
      }
    },
    async initCustomer() {
      var vm = this
      vm.getIntent()
      vm.$store.dispatch('loadStatus')
    },
    onCountdownEnd() {
      this.$store.commit('REMOVE_DELAY_IMPORT', {
        pageid: this.selectedBot.pageid
      })
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * 100 - 100
        this.getMoreCustomers()
      }
    },
    estimateReach: function (data) {
      var vm = this

      vm.loadingEstimate = true
      api.estimateReach(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.loadingEstimate = false
          return
        }
        if (response.data) {
          vm.total_user = response.data.total
        }
        vm.loadingEstimate = false
      })
    },
    checkTag(obj) {
      this.errorFilterTag = []
      if (obj.tag.text.length > 20) {
        this.errorFilterTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addTags: function (newTags) {
      this.tags = newTags
    },
    checkStatus(obj) {
      this.errorFilterStatus = []
      if (obj.tag.text.length > 20) {
        this.errorFilterStatus.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterStatus.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addStatus: function (newTags) {
      this.status = newTags
    },
    clearSearch: function () {
      this.filter = {
        fullname: '',
        gender: {
          label: this.$t('All'),
          value: 'all'
        },
        locale: null,
        app: {
          label: this.$t('All'),
          value: 'all'
        },
        intent: null,
        messagesent: {
          value: null,
          symbol: {
            value: 'g__',
            label: this.$t('Greater than')
          }
        },
        timezone: {
          from: -12,
          to: 14
        },
        activeDate: {
          enable: false,
          start: null,
          end: null
        },
        registerDate: {
          enable: false,
          start: null,
          end: null
        },
        tags: '',
        status: ''
      }
      this.$forceUpdate()

      this.onSearch()
    },
    onSearch: function () {
      var vm = this
      vm.$validator.validate().then(async (result) => {
        if (!result) {
          vm.goToErrorInput()
          return false
        }
        vm.offset = 0
        vm.hasNext = true
        vm.users = []
        vm.loading = true
        try {
          const users = await vm.getLoadUsers(vm.limit, vm.offset)
          vm.users = vm.users.concat(users)
        } catch (error) {
          console.error(error)
        }
        vm.loading = false
      })
    },
    collectexportcustomersanalytic() {
      var vm = this
      let data = {
        pageid: vm.pageid,
        grouptype: vm.grouptype,
        filter: vm.filter,
        limit: vm.limit,
        offset: vm.offset
      }

      api.putcollectexportcustomersanalytic(data, function (error, response) {
        if (error) {
          console.error(error)

          return
        }
      })
    },
    getLoadUsers: function (limit, offset) {
      let vm = this
      return new Promise((resolve, reject) => {
        const { sortBy, descending } = this.pagination
        let data = {
          pageid: vm.pageid,
          grouptype: vm.grouptype,
          filter: vm.filter,
          limit: limit,
          offset: offset,
          statustype: vm.filter.statustype,
          sortBy: sortBy,
          descending: descending
        }

        if (this.selectedBot.type == 'summithr') {
          data.member_status = vm.filter.member_status
        }

        if (this.$store.state.selectedBot.pageid == '100701258941039') {
          data.registertimestamp_from = vm.selectedDate.start
          data.registertimestamp_to = vm.selectedDate.end
        }
        var selectedApi = 'getAllUsers'
        if (['ticket2', 'studio7'].includes(this.$store.state.selectedBot.theme)) {
          selectedApi = 'getcom7getallusers'
          data.pageid = this.selectedCom7page.pageid
            ? this.selectedCom7page.pageid
            : this.selectedBot.pageid
        }
        api[selectedApi](data, function (error, response) {
          if (error) {
            reject(error)
          }

          if (vm.limit > response.data.length) {
            vm.hasNext = false
          }

          var users = response.data
          vm.total_user = response.count
          resolve(users)
        })
      })
    },
    async getMoreCustomers() {
      var vm = this
      vm.loading = true
      try {
        const users = await vm.getLoadUsers(vm.limit, vm.offset)
        vm.users = users
      } catch (error) {
        console.error(error)
      }
      vm.loading = false
    },
    onFailLoad: function (index) {
      this.$set(this.users[index], 'profile_pic', '/static/img/assets/livechat/profile.png')
    },
    getFormatDate: function (date, format) {
      return moment(date).format(format)
    },
    onActiveStartDate: function (value) {
      var vm = this
      if (moment(this.filter.activeDate.end).isBefore(value)) {
        this.filter.activeDate.end = value
      }
      this.filter.activeDate.start = value
    },
    onActiveEndDate: function (value) {
      var vm = this
      if (moment(value).isBefore(this.filter.activeDate.start)) {
        this.filter.activeDate.start = value
      }
      this.filter.activeDate.end = value
    },
    onRegisterStartDate: function (value) {
      var vm = this
      if (moment(this.filter.registerDate.end).isBefore(value)) {
        this.filter.registerDate.end = value
      }
      this.filter.registerDate.start = value
    },
    onRegisterEndDate: function (value) {
      var vm = this
      if (moment(value).isBefore(this.filter.registerDate.start)) {
        this.filter.registerDate.start = value
      }
      this.filter.registerDate.end = value
    },
    getIntent: function (callback) {
      let vm = this
      let auth = null
      let data = {
        pageid: vm.pageid
      }
      var selectedApi = 'getIntent'
      if (['ticket2', 'studio7'].includes(this.$store.state.selectedBot.theme)) {
        selectedApi = 'getcom7intents'
        data.pageid = this.selectedCom7page.pageid
          ? this.selectedCom7page.pageid
          : this.selectedBot.pageid
      }
      api[selectedApi](data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
        if (response.data) {
          var isFoundDefault = false
          $.each(response.data, function (index, val) {
            var intent = val
            intent.isShow = false
            if (vm.intents) {
              vm.intents.push(intent)
            }
          })
        }
        if (callback) {
          callback()
        }
      })
    },

    async exportDataSummary(offset) {
      let vm = this
      var limit = 5000
      vm.loading = true

      var users = await vm.getLoadUsers(limit, offset)
      if (users && users.length > 0) {
      }
      var json = []
      if (typeof users !== 'undefined') {
        users.map((item) => {
          var userid =
            vm.$store.getters.getPackage == 'premium'
              ? item.id
                ? item.id
                : '-'
              : this.$t('premium')
          var userid_split = null
          try {
            userid_split = item.app == 'line' ? userid.split('__')[0] : userid
          } catch (error) {
            userid_split = userid
          }
          var userData = {
            pageuid: userid_split,
            'Social Name':
              (item.first_name ? item.first_name : '') +
              ' ' +
              (item.last_name ? item.last_name : ''),
            'E-mail': item.email,
            Phone: item.phoneno
          }
          if (item.session) {
            Object.assign(userData, JSON.parse(item.session))
          }
          json.push(userData)
        })
        const dataWS = XLSX.utils.json_to_sheet(json)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, dataWS)
        XLSX.writeFile(wb, 'zwiz-data-summary.csv')
        vm.loading = false
      }
      vm.collectexportcustomersanalytic()
    },

    exportCustomer: function (offset = 0) {
      let vm = this
      let csvContent = ''

      var limit = 5000
      vm.loading = true

      vm.getLoadUsers(limit, offset).then(
        function (users) {
          if (users && users.length > 0) {
            var json = []
            $.each(users, function (index, val) {
              let locale = config.locale.find(function (locale) {
                if (val.locale == locale.value) {
                  return true
                }
              })
              var userid =
                vm.$store.getters.getPackage == 'premium'
                  ? val.id
                    ? val.id
                    : '-'
                  : vm.$t('premium')
              var userid_split = null
              try {
                userid_split = val.app == 'line' ? userid.split('__')[0] : userid
              } catch (error) {
                userid_split = userid
              }
              var tempJson = val.json_variable ? JSON.parse(val.json_variable) : {}
              var memberid = tempJson && tempJson.memberId ? tempJson.memberId : ''
              if (vm.selectedBot.type == 'nextcapital') {
                var userData = {
                  memberid,
                  pageuid: userid_split,
                  'Emloployee ID': val.employee_id,
                  ...(vm.selectedBot.theme == 'scgdistribution'
                    ? {
                        [vm.$t('Shop code')]: val.cardnumber,
                        [vm.$t('Shop name')]: val.realname,
                        [vm.$t('Province')]: val.address
                      }
                    : {}),
                  'Social Name':
                    (val.first_name ? val.first_name : '') +
                    ' ' +
                    (val.last_name ? val.last_name : ''),
                  Channel: val.app,
                  Gender: val.gender,
                  'Next Capital Register Date': val.login_timestamp
                    ? moment(val.login_timestamp).format('DD/MM/YYYY')
                    : '-',
                  'Register Date': val.registertimestamp
                    ? moment(val.registertimestamp).format('DD/MM/YYYY')
                    : '-',
                  'Last Active Date': val.timestamp
                    ? moment(val.timestamp).format('DD/MM/YYYY')
                    : '-',
                  Email:
                    vm.$store.getters.getPackage == 'premium'
                      ? val.email
                        ? val.email
                        : ''
                      : vm.$t('premium'),
                  Address: val.address,
                  'Phone No':
                    vm.$store.getters.getPackage == 'premium' ? val.phoneno : vm.$t('premium'),
                  Status: vm.$store.getters.getPackage == 'premium' ? val.status : vm.$t('premium'),
                  Tag: vm.$store.getters.getPackage == 'premium' ? val.tags : vm.$t('premium'),
                  Locale: locale ? locale : ''
                }
              } else {
                var userData = {
                  memberid,
                  pageuid: userid_split,
                  'Emloployee ID': val.employee_id,
                  ...(vm.selectedBot.theme == 'scgdistribution'
                    ? {
                        [vm.$t('Shop code')]: val.cardnumber,
                        [vm.$t('Shop name')]: val.realname,
                        [vm.$t('Province')]: val.address
                      }
                    : {}),
                  'Social Name':
                    (val.first_name ? val.first_name : '') +
                    ' ' +
                    (val.last_name ? val.last_name : ''),
                  Channel: val.app,
                  Gender: val.gender,
                  'Register Date': val.registertimestamp
                    ? moment(val.registertimestamp).format('DD/MM/YYYY')
                    : '-',
                  'Last Active Date': val.timestamp
                    ? moment(val.timestamp).format('DD/MM/YYYY')
                    : '-',
                  Email:
                    vm.$store.getters.getPackage == 'premium'
                      ? val.email
                        ? val.email
                        : ''
                      : vm.$t('premium'),
                  Address: val.address,
                  'Phone No':
                    vm.$store.getters.getPackage == 'premium' ? val.phoneno : vm.$t('premium'),
                  Status: vm.$store.getters.getPackage == 'premium' ? val.status : vm.$t('premium'),
                  Tag: vm.$store.getters.getPackage == 'premium' ? val.tags : vm.$t('premium'),
                  Locale: locale ? locale : ''
                }
              }
              if (
                vm.selectedBot.pageid == '105911105134578' ||
                vm.selectedBot.pageid == '101931352240400' ||
                vm.selectedBot.type == 'hopinnhr' ||
                vm.$store.state.pageListSingGaling.includes(vm.selectedBot.pageid)
              ) {
                // the next face demo
                let obj = ''
                try {
                  userData.userid = val.id.toString()
                  obj = JSON.parse(val.session)
                  delete obj.ep
                  userData.savesession = obj && Object.keys(obj).length ? JSON.stringify(obj) : ''
                } catch (error) {
                  userData.savesession = ''
                }
              }

              json.push(userData)
            })

            // vm.exportCsv(csvContent, 'zwiz-customer-' + offset)
            const dataWS = XLSX.utils.json_to_sheet(json)
            const csv = XLSX.utils.sheet_to_csv(dataWS)
            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, dataWS)
            XLSX.writeFile(wb, 'zwiz-customer.csv')
            vm.loading = false
          } else {
            vm.loading = false
          }
        },
        function () {
          vm.loading = false
        }
      )
      vm.collectexportcustomersanalytic()
    },
    onExportCustomer(type) {
      this.exportType = type
      this.exportpagecount = Math.ceil(this.total_user / this.exportlimit)

      if (this.exportpagecount > 1) {
        this.showExport = true
      } else {
        if (this.exportType === 'dataSummary') {
          this.exportDataSummary(0)
        } else if (this.exportType === 'info' || true) {
          this.exportCustomer(0)
        }
      }
    },
    importCustomer: function () {
      var vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to import customer?'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            var data = {
              pageid: vm.selectedBot.pageid
            }
            vm.loading = true
            vm.offset = 0
            vm.hasNext = true
            vm.users = []
            api.insertUsersFromInbox(data, async function (error, response) {
              if (error) {
                vm.loading = false
                return
              }
              if (response.responsecode == 200) {
                api.insertUsersFromDone(data, function (error, response) {
                  vm.getLoadUsers(vm.limit, vm.offset).then(
                    function (users) {
                      vm.users = vm.users.concat(users)
                      vm.delayImport = true
                      var time = moment().add(1, 'hours').format('YYYY-MM-DD HH:mm:ss')
                      vm.$store.commit('SET_DELAY_IMPORT', {
                        pageid: vm.selectedBot.pageid,
                        time: time
                      })
                      vm.$swal.fire({
                        title: vm.$t('Import customer successful'),
                        type: 'success',
                        confirmButtonText: vm.$t('Confirm'),
                        cancelButtonText: vm.$t('cancel'),
                        reverseButtons: true
                      })
                      vm.loading = false
                    },
                    function (error) {
                      vm.loading = false
                    }
                  )
                })
              }
            })
          }
        })
    }
  },
  watch: {
    pagination: {
      async handler() {
        this.loading = true
        try {
          this.users = await this.getLoadUsers(this.limit, this.offset)
        } catch (error) {
          console.error(error)
        }
        this.loading = false
      },
      deep: true
    },
    count: function (newVal, oldVal) {
      let vm = this
      if (newVal != oldVal) {
        vm.$emit('onUserLoaded', vm.count)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/view/dashboard/Customers.js